import ProjectCard from "./ProjectCard";
import projects from "../data/projects";

const companyProjects = projects.filter(
  (project) => project.category === "company",
);
const soloProjects = projects.filter((project) => project.category === "solo");

const ProjectGrid = ({ items }) => (
  <div className="grid gap-x-4 gap-y-4 grid-cols-1 lg:grid-cols-2">
    {items.map(({ slug, imgSrc, title, tags }) => (
      <ProjectCard
        key={slug}
        slug={slug}
        imgSrc={imgSrc}
        title={title}
        tags={tags}
      />
    ))}
  </div>
);

const Work = () => {
  return (
    <section id="projects" className="section">
      <div className="container">
        <h2 className="headline-2 mb-8 reveal-up">My Recent Works</h2>

        <div className="mb-14">
          <h3 className="text-xl font-semibold text-zinc-100 mb-2 reveal-up">
            Functioning under Companies
          </h3>
          <p className="text-zinc-400 text-sm mb-6 reveal-up">
            <a
              className="text-sky-400 transition-colors hover:text-sky-300"
              href="https://tankwatravels.com"
              target="_blank"
              rel="noreferrer"
            >
              Tankwa Tours &amp; Travels
            </a>{" "}
            |{" "}
            <a
              className="text-sky-400 transition-colors hover:text-sky-300"
              href="https://www.bdu.edu.et/bit"
              target="_blank"
              rel="noreferrer"
            >
              Bahir Dar University - BiT
            </a>
          </p>
          <ProjectGrid items={companyProjects} />
        </div>

        <div>
          <h3 className="text-xl font-semibold text-zinc-100 mb-6 reveal-up">
            Solo Projects
          </h3>
          <ProjectGrid items={soloProjects} />
        </div>
      </div>
    </section>
  );
};

export default Work;
